import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Smart Watch",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Stay connected and track your health with our feature-rich smart watch. Designed for everyday use, it combines style, performance, and convenience.",
        description: "Our Smart Watch offers a seamless blend of functionality and fashion. Equipped with heart rate monitoring, step tracking, message notifications, and more, it supports your lifestyle around the clock. Its sleek design and long battery life make it an essential gadget for anyone on the go.",
        category: ["Smart Devices", "Wearable Tech"],
        tags: ["smart", "wearable", "wireless"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "TechTime" },
            { id: 2, title: "Battery Life", content: "7 days" },
            { id: 3, title: "Water Resistance", content: "IP68" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emily Davis",
                date: "Dec 31, 2023",
                rating: 4.5,
                content: "This smart watch is fantastic for tracking workouts and receiving alerts. It looks great and works flawlessly!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Michael Johnson",
                date: "Jan 01, 2024",
                rating: 4.5,
                content: "Really impressed with the features and battery life. Perfect for both fitness and daily use."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Drone Delivery",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Revolutionize your logistics with our advanced drone delivery system. Fast, reliable, and automated for modern businesses and tech-savvy consumers.",
        description: "Our Drone Delivery solution is built for speed and efficiency, ideal for transporting lightweight packages to short-range destinations. Featuring GPS navigation, obstacle avoidance, and real-time tracking, this drone ensures safe and prompt deliveries. Great for e-commerce, medical, or smart city applications.",
        category: ["Smart Devices", "Delivery Solutions"],
        tags: ["delivery", "robotic", "smart"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "AirFleet" },
            { id: 2, title: "Range", content: "10 km" },
            { id: 3, title: "Payload Capacity", content: "2 kg" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Ava Thompson",
                date: "Dec 22, 2023",
                rating: 4.5,
                content: "This drone made our local deliveries quicker and more fun to manage. It's efficient and futuristic!"
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Liam Martinez",
                date: "Jan 03, 2024",
                rating: 4.0,
                content: "Solid drone for quick package drops. Impressive GPS accuracy and stability during flights."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Delivery Robot",
        price: 50,
        disprice: 40,
        stock: 4,
        content: "Streamline last-mile logistics with our smart delivery robot. Designed for safety, efficiency, and seamless urban mobility.",
        description: "The Delivery Robot offers autonomous navigation and secure storage, making it ideal for delivering food, parcels, or essentials in urban environments. It features real-time tracking, obstacle detection, and weather resistance. Perfect for contactless delivery in smart cities and campuses.",
        category: ["Delivery Solutions", "Smart Devices"],
        tags: ["robotic", "delivery", "smart"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "RoboServe" },
            { id: 2, title: "Speed", content: "6 km/h" },
            { id: 3, title: "Navigation", content: "Lidar + GPS" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Sophia Lee",
                date: "Dec 28, 2023",
                rating: 4.5,
                content: "This robot handles deliveries on our campus flawlessly. Great tech and very reliable!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Ethan Brown",
                date: "Jan 04, 2024",
                rating: 4.0,
                content: "Smart, responsive, and super helpful for contactless delivery—definitely the future of logistics."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Wireless Chargers",
        price: 50,
        disprice: 40,
        stock: 0,
        content: "Charge your devices effortlessly with our fast and reliable wireless chargers, designed for modern convenience and speed.",
        description: "Our Wireless Chargers provide fast and safe charging for all Qi-enabled devices. With a sleek, compact design and smart temperature control, these chargers are perfect for your desk, bedside, or travel bag. Say goodbye to tangled cables and enjoy a clutter-free charging experience.",
        category: ["Smart Devices", "Wearable Tech"],
        tags: ["charging", "wireless", "smart"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "ChargePro" },
            { id: 2, title: "Compatibility", content: "Qi-Enabled Devices" },
            { id: 3, title: "Charging Power", content: "15W Fast Charge" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Ava Wilson",
                date: "Jan 06, 2024",
                rating: 4.5,
                content: "Super convenient! Charges my phone quickly and looks great on my desk."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Liam Martinez",
                date: "Jan 08, 2024",
                rating: 4.0,
                content: "Really happy with this charger. No more cable mess—just drop and go!"
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Wireless Earbuds",
        price: 50,
        disprice: 40,
        stock: 9,
        content: "Enjoy immersive sound with our wireless earbuds, offering crystal-clear audio and a sleek, comfortable fit for on-the-go listening.",
        description: "Our Wireless Earbuds deliver premium sound quality with noise isolation, touch controls, and up to 24 hours of battery life with the charging case. With Bluetooth 5.2 for stable connections and a lightweight design, they’re perfect for music lovers and busy lifestyles alike.",
        category: ["Wearable Tech", "Smart Devices"],
        tags: ["audio", "wireless", "wearable"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SoundWave" },
            { id: 2, title: "Battery Life", content: "Up to 24 hours" },
            { id: 3, title: "Connectivity", content: "Bluetooth 5.2" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Sophia Bennett",
                date: "Jan 12, 2024",
                rating: 4.5,
                content: "Fantastic audio quality and super comfortable to wear. Great for my workouts and commutes!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Jackson Lee",
                date: "Jan 14, 2024",
                rating: 4.0,
                content: "Really good earbuds for the price. Love the design and sound clarity."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Vacuum Cleaner",
        price: 50,
        disprice: 40,
        stock: 5,
        content: "Keep your space spotless with our powerful vacuum cleaner, designed for deep cleaning on carpets, floors, and hard-to-reach areas.",
        description: "Our Vacuum Cleaner offers high suction power, multi-surface cleaning modes, and a HEPA filter to trap allergens. With a lightweight build, extended cord, and easy-to-empty dust bin, it ensures efficient, hassle-free cleaning for your home or office.",
        category: ["Cleaning Equipment", "Smart Devices"],
        tags: ["cleaning", "smart", "robotic"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "CleanSweep" },
            { id: 2, title: "Power", content: "1200W" },
            { id: 3, title: "Filter Type", content: "HEPA" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Liam Carter",
                date: "Feb 10, 2024",
                rating: 4.5,
                content: "Strong suction and very easy to handle. Works great on both carpets and tiles!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Ava Martinez",
                date: "Feb 12, 2024",
                rating: 4.0,
                content: "Lightweight and effective. Cleaning is no longer a chore with this vacuum."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Video Surveillance",
        price: 50,
        disprice: 40,
        stock: 3,
        content: "Protect your property with our advanced video surveillance system, providing clear and reliable monitoring day and night.",
        description: "Our Video Surveillance system features high-definition cameras with night vision, motion detection, and remote viewing capabilities. Easy to install and compatible with mobile devices, it ensures comprehensive security for your home or business.",
        category: ["Home Security", "Smart Devices"],
        tags: ["security", "smart", "monitoring"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SecureVision" },
            { id: 2, title: "Resolution", content: "1080p HD" },
            { id: 3, title: "Features", content: "Night Vision, Motion Detection" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Olivia Brown",
                date: "Mar 05, 2024",
                rating: 4.7,
                content: "The video quality is excellent, and I love the night vision feature. Makes me feel safer at home."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Ethan Clark",
                date: "Mar 07, 2024",
                rating: 4.3,
                content: "Easy to set up and monitor remotely. Definitely a good investment for home security."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Smart Locks",
        price: 50,
        disprice: 40,
        stock: 0,
        content: "Enhance your home security with our smart locks, offering keyless entry and remote control for convenience and safety.",
        description: "Our Smart Locks provide secure, easy access with features like fingerprint recognition, mobile app control, and auto-locking. Designed for durability and compatibility with most doors, they are perfect for modern smart homes.",
        category: ["Home Security", "Smart Devices"],
        tags: ["security", "smart", "home"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "LockSafe" },
            { id: 2, title: "Access", content: "Fingerprint, App" },
            { id: 3, title: "Compatibility", content: "Most Doors" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Mia Wilson",
                date: "Apr 10, 2024",
                rating: 4.6,
                content: "Very convenient and secure. The fingerprint feature works flawlessly."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Noah Taylor",
                date: "Apr 12, 2024",
                rating: 4.2,
                content: "Easy to install and use. Great upgrade for home security."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Gaming VR",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Immerse yourself in the next level of gaming with our advanced Gaming VR headset, offering stunning visuals and responsive controls.",
        description: "Our Gaming VR headset features high-resolution displays, a wide field of view, and ergonomic design for extended comfort. Compatible with most gaming platforms, it delivers an immersive and thrilling virtual reality experience.",
        category: ["Wearable Tech", "Smart Devices"],
        tags: ["gaming", "wearable", "smart"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "Vortex" },
            { id: 2, title: "Resolution", content: "2160 x 2160 per eye" },
            { id: 3, title: "Compatibility", content: "PC, Consoles" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Sophia Lee",
                date: "May 01, 2024",
                rating: 4.8,
                content: "Incredible immersion and very comfortable for long sessions. Highly recommend!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "James Kim",
                date: "May 03, 2024",
                rating: 4.4,
                content: "Great performance and easy setup. Makes gaming a whole new experience."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Digital Watch",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Stay on time and in style with our sleek digital watch featuring multiple functions and a modern design.",
        description: "Our Digital Watch offers a clear LED display, stopwatch, alarm, and water resistance. Perfect for everyday wear, it combines practicality with a contemporary look suitable for all occasions.",
        category: ["Wearable Tech", "Smart Devices"],
        tags: ["wearable", "smart", "time"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "TimeTech" },
            { id: 2, title: "Display", content: "LED Digital" },
            { id: 3, title: "Features", content: "Stopwatch, Alarm, Water Resistant" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Liam Scott",
                date: "Jun 15, 2024",
                rating: 4.5,
                content: "Simple yet functional watch that fits well in daily life."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Emma Green",
                date: "Jun 17, 2024",
                rating: 4.3,
                content: "Love the clear display and easy-to-use features."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Aerial Courier",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Experience fast and reliable aerial delivery services with our cutting-edge drone courier technology.",
        description: "Our Aerial Courier drones are designed for quick, safe, and efficient delivery of parcels. Equipped with GPS navigation and obstacle avoidance, they ensure timely delivery across various terrains and weather conditions.",
        category: ["Delivery Solutions", "Smart Devices"],
        tags: ["delivery", "drones", "robotic"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SkyFast" },
            { id: 2, title: "Flight Time", content: "30 mins" },
            { id: 3, title: "Range", content: "10 km" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Olivia Brown",
                date: "Jul 20, 2024",
                rating: 4.7,
                content: "Impressive delivery speed and reliability. A great solution for urgent parcels."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Ethan White",
                date: "Jul 22, 2024",
                rating: 4.4,
                content: "Easy to operate and very efficient. Makes deliveries hassle-free."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Robot Courier",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Deliver packages efficiently with our state-of-the-art Robot Courier, designed for urban and indoor deliveries.",
        description: "Our Robot Courier navigates complex environments with ease, using advanced sensors and AI to ensure safe and timely deliveries. Ideal for last-mile logistics and reducing delivery costs in crowded areas.",
        category: ["Delivery Solutions", "Smart Devices"],
        tags: ["robotic", "delivery", "smart"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "RoboSwift" },
            { id: 2, title: "Battery Life", content: "8 hours" },
            { id: 3, title: "Max Load", content: "15 kg" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Mia Johnson",
                date: "Aug 05, 2024",
                rating: 4.6,
                content: "Reliable and efficient for local deliveries. Easy to monitor and control."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Noah Martinez",
                date: "Aug 07, 2024",
                rating: 4.3,
                content: "A smart solution that cuts down delivery time and labor costs."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Cordless Charger",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Charge your devices effortlessly with our fast and efficient cordless charger, designed for convenience and portability.",
        description: "Our Cordless Charger supports multiple device compatibility, quick charging technology, and a sleek, compact design. Perfect for home, office, or travel use, it keeps your gadgets powered up without the clutter of cables.",
        category: ["Smart Devices", "Wearable Tech"],
        tags: ["charging", "wireless", "smart"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "ChargePro" },
            { id: 2, title: "Output", content: "15W Fast Charge" },
            { id: 3, title: "Compatibility", content: "Qi-Enabled Devices" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Sophia Lee",
                date: "Sep 10, 2024",
                rating: 4.8,
                content: "Convenient and fast charging with no cables to worry about!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "James Carter",
                date: "Sep 12, 2024",
                rating: 4.5,
                content: "Compact design and reliable performance. Highly recommend."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Cordless Earbuds",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Enjoy wireless freedom with our high-quality cordless earbuds, delivering crystal-clear sound and comfortable fit.",
        description: "Our Cordless Earbuds feature advanced Bluetooth connectivity, noise cancellation, and long battery life for an immersive audio experience. Perfect for workouts, commuting, and everyday use.",
        category: ["Wearable Tech", "Smart Devices"],
        tags: ["audio", "wireless", "wearable"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SoundWave" },
            { id: 2, title: "Battery Life", content: "8 Hours" },
            { id: 3, title: "Connectivity", content: "Bluetooth 5.2" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Liam Wilson",
                date: "Oct 02, 2024",
                rating: 4.7,
                content: "Excellent sound quality and very comfortable to wear all day."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Emma Harris",
                date: "Oct 04, 2024",
                rating: 4.6,
                content: "Great wireless earbuds with reliable Bluetooth connection."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Dust Remover",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Keep your space spotless with our powerful Dust Remover, designed for efficient dust and debris removal.",
        description: "Our Dust Remover features strong suction power, lightweight design, and easy-to-use controls, making it perfect for homes, offices, and vehicles. Maintain a clean environment effortlessly.",
        category: ["Cleaning Equipment", "Smart Devices"],
        tags: ["cleaning", "smart", "home"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "CleanPro" },
            { id: 2, title: "Suction Power", content: "120W" },
            { id: 3, title: "Weight", content: "1.5 kg" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Olivia Brown",
                date: "Nov 15, 2024",
                rating: 4.7,
                content: "Effective dust removal and very easy to handle."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Ethan Smith",
                date: "Nov 17, 2024",
                rating: 4.5,
                content: "Great vacuum cleaner for quick cleanups around the house."
            }
        ]
    }

];

export default products;